<div class="genre-selection-dialog">
  <h2 mat-dialog-title>Select Genres</h2>
  
  <div mat-dialog-content class="dialog-content">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading genres...</p>
    </div>

    <div *ngIf="error" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
    </div>

    <div *ngIf="!loading && !error" class="genre-content">
      <div class="selection-info">
        <p class="selected-count">
          {{ getSelectedCount() }} genre{{ getSelectedCount() !== 1 ? 's' : '' }} selected
        </p>
        <div class="action-buttons">
          <button mat-button (click)="selectAll()" [disabled]="selectedGenres.size === getTotalGenreCount()">
            Select All
          </button>
          <button mat-button (click)="clearAll()" [disabled]="selectedGenres.size === 0">
            Clear All
          </button>
        </div>
      </div>

      <div *ngIf="getSelectedCount() > 0" class="selected-genres-list">
        <h4>Currently Selected:</h4>
        <div class="selected-chips">
          <mat-chip *ngFor="let genre of getSelectedGenresArray()" 
                    class="selected-genre-chip">
            {{ getGenreDisplayName(genre) }}
            <mat-icon matChipRemove (click)="removeGenre(genre)">cancel</mat-icon>
          </mat-chip>
        </div>
      </div>

      <div class="genre-groups">
        <div *ngFor="let group of genreGroups | keyvalue" class="genre-group">
          <div class="group-header">
            <h4>{{ group.key }}</h4>
            <button mat-icon-button 
                    (click)="selectGroup(group.key)"
                    matTooltip="Select all {{ group.key.toLowerCase() }} genres"
                    class="group-select-btn">
              <mat-icon>add_circle_outline</mat-icon>
            </button>
          </div>
          
          <div class="genre-chips">
            <mat-chip-set>
              <mat-chip 
                *ngFor="let genre of getGenresByGroup(group.key)"
                [class.mat-mdc-chip-selected]="isGenreSelected(genre)"
                (click)="toggleGenre(genre)"
                class="genre-chip">
                {{ getGenreDisplayName(genre) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button 
            color="primary" 
            (click)="onSave()"
            [disabled]="selectedGenres.size === 0">
      Save Selection
    </button>
  </div>
</div>